const EMAIL_RE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const STORAGE_DIR_NAME = 'user';

const ROLES = {
    CUSTOMER: 'CUSTOMER',
    ACCOUNT_MANAGER: 'ACCOUNT_MANAGER',
    ADMIN: 'ADMIN'
};
const STATUS = {
    ACTIVE: 'ACTIVE',
    DISABLED: 'DISABLED'
};

const AREA_CODE_MAX_LEN = 5;
const NATIONAL_NUMBER_MAX_LEN = 15;
const NAME_MAX_LEN = 50;
const EMAIL_MAX_LEN = 62;




exports = module.exports = {
    EMAIL_RE,
    STORAGE_DIR_NAME,
    ROLES,
    STATUS,
    AREA_CODE_MAX_LEN,
    NATIONAL_NUMBER_MAX_LEN,
    NAME_MAX_LEN,
    EMAIL_MAX_LEN
}